enum AiTone {
  FUNNY = "funny",
  WARM = "warm",
  CAPTIVATING = "captivating",
  ELEGANT = "elegant",
  INFORMATIVE = "informative",
}

export default AiTone;
